import React from 'react';
import StepCard from './StepCard';

export default function HowAiWorkSection({styles}) {
  return (
    <section className={`${styles.container} ${styles.howItWorksSection}`}>
          <div className={styles.headingContainer}>
            <h1 className={styles.sectionTitle}>How Instant AI works</h1>
            <p className={styles.sectionSubTitle}>
              Turn every visitor into revenue with AI that learns your brand and delivers perfectly-timed, personalized emails.
            </p>
          </div>
          <ul className={styles.stepContainer}>
            <li className="half-width">
              <StepCard
                stepNumber={1}
                icon={<img src="/images/icons/focus.webp" alt="Focus Icon" />}
                title="AI Masters Your Brand Identity"
                description="Instant AI analyzes your brand voice and style to create email templates that reflect your identity, no generic marketing here."
              />
            </li>

            <li className={styles.arrow}>
              <img src="/images/stepArrow.svg" alt="arrow" />
            </li>

            <li className="half-width">
              <StepCard
                stepNumber={2}
                icon={
                  <img
                    src="/images/icons/EnvelopeOpen.webp"
                    alt="Email Icon"
                  />
                }
                title="Smart Automation Takes Over"
                description="Set up smart flows once, and let AI handle welcome emails, abandoned carts, follow-ups, and win-back campaigns."
              />
            </li>

            <li className={styles.arrow}>
              <img src="/images/stepArrow.svg" alt="arrow" />
            </li>

            <li className="half-width">
              <StepCard
                stepNumber={3}
                icon={
                  <img src="/images/icons/cartIcon.webp" alt="Cart Icon" />
                }
                title="Perfect Timing, Every Time"
                description="Our AI predicts when customers are ready to engage, sending personalized emails at the perfect moment."
                titleWidth="108px"
              />
            </li>

            <li className={styles.arrow}>
              <img src="/images/stepArrow.svg" alt="arrow" />
            </li>

            <li className="half-width">
              <StepCard
                stepNumber={4}
                icon={
                  <img src="/images/icons/stockIcon.webp" alt="Stock Icon" />
                }
                title="Watch Revenue Multiply"
                description="Monitor results as Instant AI turns browsers into buyers, boosts average orders, and re-engages inactive customers."
                titleWidth="108px"
              />
            </li>
          </ul>
        </section>
  );
}